import { useValidateAlwaysFails, } from "formvalidation/hooks";
import React from "react";
import NoBankAccountsMessageBox from "components/MessageBox/NoBankAccountsMessageBox";


const NoBankAccountsWarning = () => {
  const validation = useValidateAlwaysFails({ key: "bankAccount", title: RESX.BankAccount.resxBankAccount });

  return <NoBankAccountsMessageBox color="red" ref={validation.ref} />
}

export default NoBankAccountsWarning;